<template>
  <div style="display: inline-block; width: 100%;">
    <div class="card card-map">
      <div class="card-header ">
        <div class="row inline-100">
          <div class="col-lg-5 col-md-12">
            <label for="">
              <span>{{$t('settingsZone.edit')}}:</span>
              <input type="text"
                      v-model="zone.name"
                      :placeholder="$t('settingsZone.edit')"
                      :class="{'is-invalid': nameInvalid}"
                      class="form-control ">
            </label>
            <label v-if="taxesVersion !== 2" v-show="zone.delivery_range_cost_rules && zone.delivery_range_cost_rules.length == 0">
              <span>{{$t('settingsOrdering.shippingCost')}} ({{currency}}):</span>
                <input type="number"
                      class="form-control "
                      min="0"
                      v-model="zone.shipping_cost"
                >
            </label>
            <label v-if="taxesVersion !== 2">
              <span>{{$t('catalogCateg.vat')}}<small>({{$t('catalogCateg.included')}})</small></span>
              <select
                v-model="zone.shipping_cost_vat_id"
                class="form-control"
                style="width: 227.25px !important">
                <option value="null">{{ $t('vat.selectVat') }}</option>
                <option
                  v-for="vat in vatOptionsForLocation"
                  :key="vat.id"
                  :value="vat.id"
                  :id="vat.id"
                >{{ vat.amount }}
                </option>
                <option style="display: none" :value="zone.vat" v-if="zone.vat !== null">{{ zone.vat }}</option>
              </select>
            </label>
          </div>
          <div class="col-lg-2 col-md-0"></div>
          <div class="col-lg-5 col-md-12">
            <div v-if="taxesVersion !== 2" class="fields">
              <label v-show="zone.delivery_range_cost_rules && zone.delivery_range_cost_rules.length == 0">
                <span>{{$t('settingsOrdering.posId')}}:</span>
                <input type="text"
                        class="form-control "
                        v-model="zone.shipping_pos_id"
                >
              </label>
              <label v-show="zone.delivery_range_cost_rules && zone.delivery_range_cost_rules.length == 0">
                <span>{{$t('settingsOrdering.minimumOrderValue')}} ({{currency}}):</span>
                <input type="text"
                        class="form-control"
                        v-model="zone.min_order_value"
                >
              </label>
              <label v-show="zone.delivery_range_cost_rules && zone.delivery_range_cost_rules.length == 0">
                <span>{{$t('settingsOrdering.extraDeliveryTime')}} ({{$t('general.minutes')}}):</span>
                <input type="number"
                        v-validate="{min: 0}"
                        class="form-control"
                        :placeholder="$t('general.minutes')"
                        v-model="zone.extra_delivery_time"
                >
              </label>
            </div>
          </div>
          <div class="col-lg-12 col-md-12" v-if="taxesVersion !== 2 && googleMapsapiKey">
            <br>
            <div class="form-group">
              <div class="card" style="box-shadow: none; border: 1px solid #dcdfe6;">
                <div class="card-content">
                  <div class="prod-tabs" direction="horizontal" type="tabs">
                    <div class="col-md-12 display-flex align-items-center justify-content-space-between">
                      <h6>{{$t('settingsOrdering.extraCostRange')}}</h6>
                      <button class="btn btn-info btn-icon "
                              @click.prevent="addCostRules()"
                              :title="$t('general.add')  + ' ' + $t('catalogProdOpt.single')" >
                          <i class="ti-plus"></i>
                      </button>
                    </div>
                    <div class="col-md-12 pad-lf-0 pad-rg-0">
                      <hr class="sm">
                    </div>
                    <div :title="$t('catalogProdOpt.plural')" class="text-left">
                      <div class="row">
                        <div class="col-md-12" >
                          <p v-if="zone.delivery_range_cost_rules && zone.delivery_range_cost_rules.length == 0" class="">No options added yet.</p>
                          <el-collapse ref="elColl" v-model="zoneCostRulesIndex" accordion>
                            <div class="align" v-for="item in visibleCostRanges" :key="item.costRange.id || item.idxO">
                                <el-collapse-item class="customItem" :title="$t('settingsOrdering.panaLa') + item.costRange.distance_in_km + ' km'" :name="item.idxO">
                                  <div class="clearfix"><hr class="no-margin mar-bt-15" /></div>
                                  <div class="boxCostRange">
                                    <label>
                                      <span>{{$t('settingsOrdering.distanceInKm')}}:</span>
                                        <input type="number"
                                              class="form-control"
                                              :class="{'is-invalid': costRangeDistanceHasError(item.idxO, item.costRange)}"
                                              min="0"
                                              required
                                              v-model="item.costRange.distance_in_km"
                                              @blur="touchCostRangeDistance(item.idxO, item.costRange)"
                                              @input="validateCostRangeDistance(item.idxO, item.costRange)"
                                        >
                                    </label>
                                    <label>
                                      <span>{{$t('settingsOrdering.shippingCost')}} ({{currency}}):</span>
                                        <input type="number"
                                              class="form-control "
                                              min="0"
                                              v-model="item.costRange.shipping_cost"
                                        >
                                    </label>
                                    <label>
                                      <span>{{$t('settingsOrdering.posId')}}:</span>
                                      <input type="text"
                                              class="form-control "
                                              v-model="item.costRange.shipping_pos_id"
                                      >
                                    </label>
                                    <label>
                                      <span>{{$t('settingsOrdering.minimumOrderValue')}} ({{currency}}):</span>
                                      <input type="text"
                                              class="form-control"
                                              v-model="item.costRange.min_order_value"
                                      >
                                    </label>
                                    <label>
                                      <span>{{$t('settingsOrdering.extraDeliveryTime')}} ({{$t('general.minutes')}}):</span>
                                      <input type="number"
                                              v-validate="{min: 0}"
                                              class="form-control"
                                              :placeholder="$t('general.minutes')"
                                              v-model="item.costRange.extra_delivery_time"
                                      >
                                    </label>
                                  </div>
                                </el-collapse-item>
                                <div class="closeBtn">
                                  <button class="btn btn-danger pull-left btn-icon mar-15" :title="$t('general.delete')" @click.prevent="deleteCostRules(item.idxO)"><i class="ti-close"></i></button>
                                </div>
                            </div>
                          </el-collapse>
                        </div>
                        <div class="col-md-12 pad-to-15 pad-bt-10">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="taxesVersion === 2" class="col-lg-12 col-md-12 delivery-tax-zone-wrap">
            <delivery-tax-panel
              v-if="zone && zone.id"
              :location-id="location_id"
              :delivery-range-id="zone && zone.id"
              :currency="currency"
            ></delivery-tax-panel>
            <div v-else class="delivery-tax-zone-save-first"><i class="fa fa-info-circle"></i> Salvează zona înainte să îi atribui taxe de livrare.</div>
          </div>
          <div class="col-sm-12 mar-to-15">
            <div class="form-group override-payment text-left">
              <div class="checkbox mar-bt-20">
                <input type="checkbox"
                        :id="bussLocationId + '_' + indexZone + '_override_payment'"
                        v-model="zone.override_payment_method"
                        @change="emitZoneUpdate">
                <label :for="bussLocationId + '_' + indexZone + '_override_payment'">{{$t('settingsZone.overridePayment')}}</label>
              </div>
              <template v-if="zone.override_payment_method">
                <div class="checkbox mar-bt-20">
                  <input type="checkbox"
                          :id="bussLocationId + '_' + indexZone + '_accept_cash'"
                          v-model="zone.accept_cash"
                          @change="emitZoneUpdate">
                  <label :for="bussLocationId + '_' + indexZone + '_accept_cash'">{{$t('settingsZone.acceptCash')}}</label>
                </div>
                <div class="checkbox mar-bt-20">
                  <input type="checkbox"
                          :id="bussLocationId + '_' + indexZone + '_accept_card'"
                          v-model="zone.accept_card"
                          @change="emitZoneUpdate">
                  <label :for="bussLocationId + '_' + indexZone + '_accept_card'">{{$t('settingsZone.acceptCard')}}</label>
                </div>
                <div class="checkbox mar-bt-20">
                  <input type="checkbox"
                          :id="bussLocationId + '_' + indexZone + '_accept_pos'"
                          v-model="zone.accept_pos"
                          @change="emitZoneUpdate">
                  <label :for="bussLocationId + '_' + indexZone + '_accept_pos'">{{$t('settingsZone.acceptPos')}}</label>
                </div>
              </template>
            </div>
            <button class="btn btn-danger btn-fill pull-right" v-if="selectedShape" @click.prevent="deleteSelectedShape">{{$t('settingsZone.deleteShape')}}</button>
          </div>
        </div>
      </div>
      <div :id="'map_'+indexZone+'_'+bussLocationId" class="full-screen-map"></div>
    </div>
    <div class="card-footer" v-if="!hideDeleteZone">
        <button class="btn btn-danger btn-fill" @click.prevent="deleteZone(indexZone)">{{$t('settingsZone.deleteBtn')}}</button>
      </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import swal from 'sweetalert2'
  import GoogleMapsLoader from 'google-maps'
  import {API_KEY} from './API_KEY'
  import DeliveryTaxPanel from './../Settings/Taxes/DeliveryTaxPanel.vue'
  GoogleMapsLoader.KEY = API_KEY
  GoogleMapsLoader.VERSION = '3.64'
  export default {
    components: {
      DeliveryTaxPanel
    },
    computed: {
      vatOptionsForLocation () {
        if (this.taxesVersion === 2) {
          return this.vatOptions || []
        }
        return (this.vatOptions || []).filter(vat => this.bussLocationId === vat.location_token)
      },
      visibleCostRanges () {
        const rules = (this.zone && this.zone.delivery_range_cost_rules) ? this.zone.delivery_range_cost_rules : []
        return rules
          .map((costRange, idxO) => ({ costRange, idxO }))
          .filter(x => !x.costRange.deleted)
      }
    },
    data () {
      return {
        zoneCostRulesIndex: 0,
        flagEventIsAdded: 0,
        draw: {},
        selectedShape: null,
        drawingManager: null,
        shape: [],
        zone: null,
        costRangeDistanceTouched: {},
        costRangeDistanceErrors: {}
      }
    },
    props: {
      location_id: null,
      nameInvalid: {
        type: Boolean,
        default: false
      },
      showTheRestOfTheZones: true,
      currency: null,
      cityFromParent: '',
      googleMapsapiKey: '',
      locationMarker: {},
      zoneInComp: {},
      deliveryRanges: {},
      indexZone: {},
      bussLocationId: {},
      orderType: {},
      taxesVersion: {
        type: Number,
        default: 1
      },
      vatOptions: {
        type: Array,
        default: () => []
      },
      // Hide the footer "delete zone" button (used by the new company-zone section,
      // which has its own delete action; the legacy location editor keeps it).
      hideDeleteZone: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.zone = this.zoneInComp
      this.resolveVatForContext()
      this.restOfZones = []
      for (var i = this.deliveryRanges.length - 1; i >= 0; i--) {
        if (!this.zone.hasOwnProperty('id') || (this.zone.hasOwnProperty('id') && this.zone.id !== this.deliveryRanges[i].id)) {
          this.restOfZones.push(this.deliveryRanges[i])
        }
      }
      this.openCostRangeWithDistanceError()
    },
    mounted () {
      // this.getVatOptions()
      GoogleMapsLoader.load((google) => {
        this.initMap(google)
      })
    },
    watch: {
      showTheRestOfTheZones () {
        GoogleMapsLoader.load((google) => {
          this.initMap(google)
        })
      },
      // VAT options can arrive after this map is created (async load); re-run the
      // context remap so a cloned zone's VAT resolves once the options are available.
      vatOptions () {
        this.resolveVatForContext()
      },
      zoneInComp: {
        deep: true,
        handler (zone) {
          this.zone = zone
          this.resolveVatForContext()
          this.openCostRangeWithDistanceError()
        }
      }
    },
    methods: {
      openCostRangeWithDistanceError () {
        this.$nextTick(() => {
          const invalidCostRange = this.visibleCostRanges.find(item => {
            return item.costRange && item.costRange.__distance_required_error
          })
          if (invalidCostRange) {
            this.zoneCostRulesIndex = invalidCostRange.idxO
          }
        })
      },
      touchCostRangeDistance (idx, costRange) {
        Vue.set(this.costRangeDistanceTouched, idx, true)
        this.validateCostRangeDistance(idx, costRange)
      },
      validateCostRangeDistance (idx, costRange) {
        const v = costRange ? costRange.distance_in_km : ''
        const hasError = (v === '' || v === null || typeof v === 'undefined')
        if (costRange && costRange.__distance_required_error && !hasError) {
          Vue.set(costRange, '__distance_required_error', false)
        }
        Vue.set(this.costRangeDistanceErrors, idx, hasError)
        return !hasError
      },
      costRangeDistanceHasError (idx, costRange) {
        if (costRange && costRange.__distance_required_error) return true
        if (!this.costRangeDistanceTouched[idx]) return false
        if (typeof this.costRangeDistanceErrors[idx] === 'undefined') {
          return !this.validateCostRangeDistance(idx, costRange)
        }
        return !!this.costRangeDistanceErrors[idx]
      },
      emitZoneUpdate () {
        this.$emit('update-zone', this.zone, this.indexZone)
      },
      addCostRules () {
        let newRow = {
          'company_id': this.zone.company_id,
          'location_id': this.location_id,
          'delivery_ranges_id': this.zone.id,
          'distance_in_km': '',
          'extra_delivery_time': '',
          'min_order_value': '',
          'shipping_cost': '',
          'shipping_pos_id': ''
        }

        if (!this.zone.hasOwnProperty('delivery_range_cost_rules')) {
          Vue.set(this.zone, 'delivery_range_cost_rules', [])
        }

        this.zone.delivery_range_cost_rules.push(newRow)
        this.$emit('update-zone', this.zone, this.indexZone)

        this.zoneCostRulesIndex = this.zone.delivery_range_cost_rules ? this.zone.delivery_range_cost_rules.length - 1 : 0
      },
      deleteCostRules (id) {
        swal({
          text: this.$t('catalogProdOpt.areyouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            Vue.set(this.zone.delivery_range_cost_rules[id], 'deleted', 1)
            this.$emit('update-zone', this.zone, this.indexZone)
          }
        })
      },
      // A zone's VAT (shipping_cost_vat_id) is a location-scoped id. When a legacy
      // location zone is cloned into a company-level zone, the map borrows a (possibly
      // different) location for its VAT options, so the copied id is not in this
      // location's list and the VAT looks empty. Remap it to the local VAT with the
      // same amount so the cloned VAT stays selected and is not lost on save.
      resolveVatForContext () {
        const current = this.zone ? this.zone.shipping_cost_vat_id : null
        if (current === null || current === undefined || current === '' || Number(current) === 0) return
        const localList = this.vatOptionsForLocation || []
        if (localList.some(v => String(v.id) === String(current))) return // already valid for this location
        const original = (this.vatOptions || []).find(v => String(v.id) === String(current))
        if (!original) return
        const match = localList.find(v => String(v.amount) === String(original.amount))
        if (match) this.$set(this.zone, 'shipping_cost_vat_id', match.id)
      },
      geolocation (address, callbackFunction) {
        let Lat = null
        let Lng = null
        var geocoder = new window.google.maps.Geocoder()
        geocoder.geocode({
          'address': address
        }, (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK) {
            Lat = results[0].geometry.location.lat()
            Lng = results[0].geometry.location.lng()
          } else {
            Lat = 47.0667
            Lng = 21.9333
          }
          if (callbackFunction) callbackFunction(Lat, Lng)
          return true
        })
      },
      getVatOptions (locaitonIds = null) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_ids: locaitonIds
        }
        this.apiRequest('/location/vat', 'GET', data, (response) => {
          if (response.status === true) {
            this.vatOptions = response.data
          }
        })
      },
      initMap (google) {
        let myLatlng = {}
        if (this.zone.shape && this.zone.shape.type === 'circle') {
          myLatlng = new google.maps.LatLng(this.zone.shape.centerLat, this.zone.shape.centerLng)
          this.initMap2(myLatlng)
        } else if (this.zone.shape && this.zone.shape.type === 'rectangle') {
          myLatlng = new google.maps.LatLng(this.zone.shape.center.lat, this.zone.shape.center.lng)
          this.initMap2(myLatlng)
        } else if (this.zone.shape && this.zone.shape.type === 'polygon' && Array.isArray(this.zone.shape.array) && this.zone.shape.array.length) {
          // A drawn polygon zone: center the map on the zone (its bounds center) instead of the location.
          const bounds = new google.maps.LatLngBounds()
          this.zone.shape.array.forEach((p) => bounds.extend(new google.maps.LatLng(p.lat, p.lng)))
          myLatlng = bounds.getCenter()
          this.initMap2(myLatlng)
        } else {
          this.geolocation(this.cityFromParent, (Lat, Lng) => {
            myLatlng = new google.maps.LatLng(Lat, Lng)
            this.initMap2(myLatlng)
          })
        }
      },
      initMap2 (myLatlng) {
        this.drawingManager = new window.google.maps.drawing.DrawingManager({
          // drawingMode: google.maps.drawing.OverlayType.MARKER,
          drawingControl: true,
          drawingControlOptions: {
            position: window.google.maps.ControlPosition.TOP_CENTER,
            drawingModes: [
              window.google.maps.drawing.OverlayType.CIRCLE,
              window.google.maps.drawing.OverlayType.POLYGON,
              window.google.maps.drawing.OverlayType.RECTANGLE
            ]
          },
          circleOptions: {
            fillColor: 'white',
            fillOpacity: 0.2,
            strokeWeight: 1,
            clickable: true,
            editable: true,
            zIndex: 1
          },
          rectangleOptions: {
            fillColor: 'white',
            fillOpacity: 0.2,
            strokeWeight: 1,
            clickable: true,
            editable: true,
            zIndex: 1
          },
          polygonOptions: {
            fillColor: 'white',
            fillOpacity: 0.2,
            strokeWeight: 1,
            clickable: true,
            editable: true,
            zIndex: 1
          }
        })
        const mapOptions = {
          zoom: 12,
          center: myLatlng,
          streetViewControl: false,
          scrollwheel: false // we disable de scroll over the map, it is a really annoing when you scroll through page
        }
        const map = new window.google.maps.Map(document.getElementById('map_' + this.indexZone + '_' + this.bussLocationId), mapOptions)
        this.drawingManager.setMap(map)

        if (this.locationMarker) {
          // const marker = new window.google.maps.Marker({
          //   position: new window.google.maps.LatLng(this.locationMarker.lat, this.locationMarker.lng),
          //   map: map,
          //   title: this.locationMarker.name
          // })
        }

        window.google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (e) => {
          if (e.type !== window.google.maps.drawing.OverlayType.MARKER) {
            // Switch back to non-drawing mode after drawing a shape.
            this.drawingManager.setDrawingMode(null)
            // To hide:
            this.drawingManager.setOptions({
              drawingControl: false
            })
            // Add an event listener that selects the newly-drawn shape when the user
            // mouses down on it.
            var newShape = e.overlay
            newShape.type = e.type
            window.google.maps.event.addListener(newShape, 'click', () => {
              this.setSelection(newShape)
            })
            this.setSelection(newShape)
          }
        })

        this.drawTheShape(map)
        if (this.showTheRestOfTheZones) {
          var colors = [
            '#FF5733', // Red
            '#3357FF', // Blue
            '#FF33A1', // Pink
            '#33FFF3', // Cyan
            '#F3FF33', // Yellow
            '#8D33FF', // Purple
            '#FF8D33', // Orange
            '#33FF8D', // Lime
            '#5733FF', // Indigo
            '#FF5733', // Coral
            '#33A1FF', // Sky Blue
            '#A1FF33', // Chartreuse
            '#FF33F3', // Magenta
            '#33FFA1'  // Mint
          ]
          for (var i = this.restOfZones.length - 1; i >= 0; i--) {
            this.drawTheShape2(map, this.restOfZones[i], colors[i % colors.length])
          }
        }
        // this.getMapCoords(google, this.drawingManager)
      },
      drawTheShape (map) {
        if (this.zone.shape) {
          if (this.zone.shape.type === 'polygon') {
            this.drawingManager.setDrawingMode(null)
            this.drawingManager.setOptions({
              drawingControl: false
            })
            this.selectedShape = new window.google.maps.Polygon({
              paths: this.zone.shape.array,
              fillColor: 'white',
              fillOpacity: 0.2,
              strokeWeight: 1,
              clickable: true,
              editable: true,
              zIndex: 1
            })
            this.selectedShape.setMap(map)
            this.selectedShape.type = this.zone.shape.type
            this.sendCoords()
          }
          if (this.zone.shape.type === 'circle') {
            this.drawingManager.setDrawingMode(null)
            this.drawingManager.setOptions({
              drawingControl: false
            })
            this.selectedShape = new window.google.maps.Circle({
              center: {'lat': this.zone.shape.centerLat, 'lng': this.zone.shape.centerLng},
              radius: this.zone.shape.centerRadius,
              fillColor: 'white',
              fillOpacity: 0.2,
              strokeWeight: 1,
              clickable: true,
              editable: true,
              zIndex: 1
            })
            this.selectedShape.setMap(map)
            this.selectedShape.type = this.zone.shape.type
            this.sendCoords()
          }
          if (this.zone.shape.type === 'rectangle') {
            this.selectedShape = new window.google.maps.Rectangle({
              fillColor: 'white',
              fillOpacity: 0.2,
              strokeWeight: 1,
              clickable: true,
              editable: true,
              zIndex: 1,
              bounds: new window.google.maps.LatLngBounds(
                        new window.google.maps.LatLng(this.zone.shape.southWestLat, this.zone.shape.southWestLng),
                        new window.google.maps.LatLng(this.zone.shape.northEastLat, this.zone.shape.northEastLng)
                      )
              // bounds: {
              //   north: this.zone.shape.northEastLat,
              //   south: this.zone.shape.northEastLng,
              //   east: this.zone.shape.southWestLat,
              //   west: this.zone.shape.southWestLng,
              // },
            })
            this.drawingManager.setDrawingMode(null)
            this.drawingManager.setOptions({
              drawingControl: false
            })
            this.selectedShape.setMap(map)
            this.selectedShape.type = this.zone.shape.type
            this.sendCoords()
          }
        }
      },
      drawTheShape2 (map, zone, color) {
        let labelPosition = null
        if (zone.shape) {
          if (zone.shape.type === 'polygon') {
            this.shape[zone.id] = new window.google.maps.Polygon({
              paths: zone.shape.array,
              fillColor: color,
              fillOpacity: 0.3,
              strokeWeight: 0,
              clickable: false,
              editable: false,
              zIndex: 1
            })
            this.shape[zone.id].setMap(map)
            this.shape[zone.id].type = zone.shape.type

            // Calcularea centrului poligonului
            const bounds = new window.google.maps.LatLngBounds()
            zone.shape.array.forEach((path) => {
              bounds.extend(new window.google.maps.LatLng(path.lat, path.lng))
            })
            labelPosition = bounds.getCenter()
          }
          if (zone.shape.type === 'circle') {
            this.shape[zone.id] = new window.google.maps.Circle({
              center: {'lat': zone.shape.centerLat, 'lng': zone.shape.centerLng},
              radius: zone.shape.centerRadius,
              fillColor: color,
              fillOpacity: 0.3,
              strokeWeight: 0,
              clickable: false,
              editable: false,
              zIndex: 1
            })
            this.shape[zone.id].setMap(map)
            this.shape[zone.id].type = zone.shape.type
            labelPosition = new window.google.maps.LatLng(zone.shape.centerLat, zone.shape.centerLng)
          }
          if (zone.shape.type === 'rectangle') {
            this.shape[zone.id] = new window.google.maps.Rectangle({
              fillColor: color,
              fillOpacity: 0.3,
              strokeWeight: 0,
              clickable: false,
              editable: false,
              zIndex: 1,
              bounds: new window.google.maps.LatLngBounds(
                        new window.google.maps.LatLng(zone.shape.southWestLat, zone.shape.southWestLng),
                        new window.google.maps.LatLng(zone.shape.northEastLat, zone.shape.northEastLng)
                      )
              // bounds: {
              //   north: zone.shape.northEastLat,
              //   south: zone.shape.northEastLng,
              //   east: zone.shape.southWestLat,
              //   west: zone.shape.southWestLng,
              // },
            })
            this.shape[zone.id].setMap(map)
            this.shape[zone.id].type = zone.shape.type

            labelPosition = this.shape[zone.id].bounds.getCenter()
          }


          // Definiția clasei LabelOverlay
          class LabelOverlay extends window.google.maps.OverlayView {
            constructor (map, position, text) {
              super()
              this.position = position
              this.text = text
              this.setMap(map)
            }
            onAdd () {
              this.div = document.createElement('div')
              this.div.style.position = 'absolute'
              this.div.style.background = color
              this.div.style.color = 'white'
              this.div.style.padding = '2px'
              this.div.style.border = '0px solid black'
              this.div.style.fontSize = '12px'
              this.div.innerHTML = this.text
              const panes = this.getPanes()
              panes.overlayLayer.appendChild(this.div)
            }
            draw () {
              const projection = this.getProjection()
              const position = projection.fromLatLngToDivPixel(this.position)
              if (this.div) {
                this.div.style.left = position.x + 'px'
                this.div.style.top = position.y + 'px'
              }
            }
            onRemove () {
              if (this.div) {
                this.div.parentNode.removeChild(this.div)
                this.div = null
              }
            }
          }

          // Creează și adaugă eticheta
          if (labelPosition) {
            const label = new LabelOverlay(map, labelPosition, zone.name)
            this.shape[zone.id].label = label // Păstrează referința la etichetă
          }
        }
      },
      setSelection (shape) {
        this.clearSelection()
        this.selectedShape = shape
        shape.setEditable(true)
        this.flagEventIsAdded = 0
        this.sendCoords()
      },
      sendCoords () {
        if (this.selectedShape.type === 'polygon') {
          if (!this.flagEventIsAdded) {
            window.google.maps.event.addListener(this.selectedShape.getPath(), 'insert_at', this.sendCoords)
            window.google.maps.event.addListener(this.selectedShape.getPath(), 'remove_at', this.sendCoords)
            window.google.maps.event.addListener(this.selectedShape.getPath(), 'set_at', this.sendCoords)
            this.flagEventIsAdded = 1
          }
          let cord = []
          const coords = this.selectedShape.getPath().getArray()
          for (var i = 0; i < coords.length; i++) {
            let coordsLat = coords[i].lat()
            let coordsLng = coords[i].lng()
            cord[i] = {
              lat: coordsLat,
              lng: coordsLng
            }
          }
          this.zone['shape'] = {
            'type': this.selectedShape.type,
            'array': cord
          }
        }
        if (this.selectedShape.type === 'circle') {
          if (!this.flagEventIsAdded) {
            window.google.maps.event.addListener(this.selectedShape, 'radius_changed', this.sendCoords)
            window.google.maps.event.addListener(this.selectedShape, 'center_changed', this.sendCoords)
            this.flagEventIsAdded = 1
          }
          const center = this.selectedShape.getCenter()
          this.zone['shape'] = {
            'type': this.selectedShape.type,
            'centerLat': center.lat(),
            'centerLng': center.lng(),
            'centerRadius': this.selectedShape.getRadius()
          }
        }
        if (this.selectedShape.type === 'rectangle') {
          if (!this.flagEventIsAdded) {
            window.google.maps.event.addListener(this.selectedShape, 'bounds_changed', this.sendCoords)
            this.flagEventIsAdded = 1
          }
          const bounds = this.selectedShape.getBounds()
          this.zone['shape'] = {
            'type': this.selectedShape.type,
            'center': {'lat': bounds.getCenter().lat(), 'lng': bounds.getCenter().lng()},
            'northEastLat': bounds.getNorthEast().lat(),
            'northEastLng': bounds.getNorthEast().lng(),
            'southWestLat': bounds.getSouthWest().lat(),
            'southWestLng': bounds.getSouthWest().lng()
          }
        }
      },
      // getMapCoords (google) {
      //   window.google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
      //     // console.log(event.type)
      //     if (event.type === 'polygon') {
      //       this.draw.type = event.type
      //       this.draw.coordonate = []
      //       const coords = event.overlay.getPath().getArray()
      //       for (var i = 0; i < coords.length; i++) {
      //         let coordsLat = coords[i].lat()
      //         let coordsLng = coords[i].lng()
      //         // console.log('lat:', coordsLat)
      //         // console.log('lng:', coordsLng)
      //         // console.log(i)
      //         this.draw.coordonate[i] = {
      //           lat: coordsLat,
      //           lng: coordsLng
      //         }
      //       }
      //       // console.log(this.draw)
      //     }
      //     if (event.type === 'circle') {
      //       const center = event.overlay.getCenter()
      //       const centerLat = center.lat()
      //       const centerLng = center.lng()
      //       const centerRadius = event.overlay.getRadius()
      //     }
      //     if (event.type === 'rectangle') {
      //       const bounds = event.overlay.getBounds()
      //       const start = bounds.getNorthEast()
      //       const startLat = bounds.getNorthEast().lat()
      //       const startLng = bounds.getNorthEast().lng()
      //       const end = bounds.getSouthWest()
      //       const endLat = bounds.getSouthWest().lat()
      //       const endLng = bounds.getSouthWest().lng()
      //       const center = bounds.getCenter()
      //       console.log(start, startLat, startLng)
      //     }
      //     this.$bus.$emit('drawingDetails', this.draw) // emit event to OrderingManagement
      //   })
      // },
      deleteZone (indexZone) {
        let obj = {
          'action': 'delete',
          'indexZone': indexZone,
          'bussLocationId': this.bussLocationId,
          'orderType': this.orderType
        }
        this.$bus.$emit('changeDeliveryZone', obj)
      },
      deleteSelectedShape () {
        if (this.selectedShape) {
          this.selectedShape.setMap(null)
          // To show:
          this.drawingManager.setOptions({
            drawingControl: true
          })
          this.selectedShape = null
          this.zone['shape'] = null
          this.flagEventIsAdded = 0
        }
      },
      clearSelection () {
        if (this.selectedShape) {
          this.selectedShape.setEditable(false)
          this.selectedShape = null
          this.zone['shape'] = null
          this.flagEventIsAdded = 0
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .card-header {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    label {
      display: block;
      display: flex;
      align-items: center;
      justify-content: space-between;
      input {
        width: auto;
        margin-left: 10px;
      }
    }
  }

  input.is-invalid {
    border: 1px solid #dc3545 !important;
    background-color: #fff5f5;
  }

  .delivery-tax-zone-wrap {
    margin-top: 20px;
  }

  .delivery-tax-zone-save-first {
    background: #f7f8fd;
    border: 1px solid #dfe5f2;
    border-radius: 10px;
    color: #7388b5;
    padding: 18px;
    text-align: center;
  }

  // Keep the payment-override checkboxes rendering like the standard payment-method
  // checkboxes, unaffected by the flex layout applied to `.card-header label`.
  .override-payment {
    margin-bottom: 15px;
    .checkbox {
      label {
        display: inline-block;
        justify-content: flex-start;
      }
      input {
        margin-left: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Maps/DeliveryGoogleMaps.vue